.booth {
  cursor: pointer !important;
  fill: var(--map-theme);

  &:hover {
    fill: #ffffff;
  }

  &[aria-checked='true'] rect {
    fill: #fff;
    stroke: #fff;
    stroke-linejoin: round;
    stroke-width: 3px;
    animation-name: highlight-booth;
    animation-duration: 1.2s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
  }
}

@keyframes highlight-booth {
  0% {
    fill: transparent;
    stroke-width: 3px;
  }
  25% {
    fill: #fff;
    stroke-width: 10px;
  }
  100% {
    fill: transparent;
    stroke-width: 3px;
  }
}
